import { render, staticRenderFns } from "./PlayAudioControl.vue?vue&type=template&id=36d79798"
import script from "./PlayAudioControl.vue?vue&type=script&lang=js"
export * from "./PlayAudioControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports